<template>
  <div class="row gy-0 gx-10 justify-center">
    <!--begin::Col-->

    <div class="col-12 col-sm-8 col-lg-4">
      <a
        href="#adminComponent"
        @click="setView(addItem)"
        class="btn btn-primary fw-bold px-6 py-5 w-100 mb-4 mt-6"
        data-bs-toggle="modal"
        data-bs-target="#kt_modal_create_app"
      >
        Add items
        <svg
          width="22"
          height="23"
          viewBox="0 0 22 23"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M10.9775 21.5121C16.4009 21.5121 20.7975 17.1156 20.7975 11.6921C20.7975 6.26869 16.4009 1.87213 10.9775 1.87213C5.55403 1.87213 1.15747 6.26869 1.15747 11.6921C1.15747 17.1156 5.55403 21.5121 10.9775 21.5121Z"
            stroke="white"
            stroke-width="2"
            stroke-linecap="round"
            stroke-linejoin="round"
          ></path>
          <path
            d="M10.9775 15.6201L14.9055 11.6921L10.9775 7.7641"
            stroke="white"
            stroke-width="2"
            stroke-linecap="round"
            stroke-linejoin="round"
          ></path>
          <path
            d="M7.04956 11.6921H14.9056"
            stroke="white"
            stroke-width="2"
            stroke-linecap="round"
            stroke-linejoin="round"
          ></path>
        </svg>
      </a>
      <CollapsibleAdminOptions v-if="!largeScreen" :options="adminOptions" @view="view"/>
      <div v-if="largeScreen" class="tab-pane fade show active" id="kt_general_widget_1_3">
        <!--begin::Tables Widget 5-->
        <div class="card">
          <!--end::Header--><!--begin::Body-->
          <div class="card-body py-3">
            <div class="tab-content">
              <!--begin::Tap pane-->
              <div
                class="tab-pane fade show active"
                id="kt_table_widget_5_tab_1"
              >
                <!--begin::Table container-->
                <div class="table-responsive">
                  <!--begin::Table-->
                  <table
                    class="table table-row-dashed table-row-gray-200 align-middle gs-0 gy-4"
                  >
                    <!--begin::Table head-->
                    <thead>
                      <tr class="border-0">
                        <!-- <th class="p-0 w-50px"></th> -->
                        <th class="p-0 min-w-150px"></th>
                        <!-- <th class="p-0 min-w-140px"></th>
																		<th class="p-0 min-w-110px"></th> -->
                        <th class="p-0 min-w-50px"></th>
                      </tr>
                    </thead>
                    <!--end::Table head--><!--begin::Table body-->
                    <tbody>
                      <tr v-for="(option, i) in adminOptions" :key="i">
                        <td>
                          <a
                            href="#adminComponent"
                            @click="setView(option.view)"
                            class="text-dark fw-bolder text-hover-primary mb-1 fs-6"
                            >{{option.label}}</a
                          >
                        </td>
                        <td class="text-end">
                          <a
                            @click="setView(option.view)"
                            class="btn btn-sm btn-icon btn-bg-light btn-active-color-primary"
                            ><!--begin::Svg Icon | path: icons/duotune/arrows/arr064.svg--><span
                              class="svg-icon svg-icon-2"
                              ><svg
                                xmlns="http://www.w3.org/2000/svg"
                                width="24"
                                height="24"
                                viewBox="0 0 24 24"
                                fill="none"
                              >
                                <rect
                                  opacity="0.5"
                                  x="18"
                                  y="13"
                                  width="13"
                                  height="2"
                                  rx="1"
                                  transform="rotate(-180 18 13)"
                                  fill="black"
                                ></rect>
                                <path
                                  d="M15.4343 12.5657L11.25 16.75C10.8358 17.1642 10.8358 17.8358 11.25 18.25C11.6642 18.6642 12.3358 18.6642 12.75 18.25L18.2929 12.7071C18.6834 12.3166 18.6834 11.6834 18.2929 11.2929L12.75 5.75C12.3358 5.33579 11.6642 5.33579 11.25 5.75C10.8358 6.16421 10.8358 6.83579 11.25 7.25L15.4343 11.4343C15.7467 11.7467 15.7467 12.2533 15.4343 12.5657Z"
                                  fill="black"
                                ></path></svg></span
                            ><!--end::Svg Icon--></a
                          >
                        </td>
                      </tr>
                    </tbody>
                    <!--end::Table body-->
                  </table>
                </div>
                <!--end::Table-->
              </div>
            </div>
          </div>
          <!--end::Body-->
        </div>
        <!--end::Tables Widget 5-->
      </div>
    </div>
    <!--end::Col-->

    <!--begin::Col-->
    <div id="adminComponent" class="col-sm-12 col-lg-8">
      <!--begin::General Widget 1-->
      <keep-alive>
        <component @added="updateNotif" @updateNotification="updateNotif" v-bind:is="activeComponent"></component>
      </keep-alive>
      <!--end::General Widget 1-->
    </div>
    <!--end::Col-->
  </div>
</template>

<script>
import mixins from "vue-typed-mixins";
import AddItem from "@/components/AddItem.vue";
import ManageCategories from "@/components/ManageCategories.vue";
import AddWorker from "@/components/AddWorker.vue";
import BarrelBreakdown from "@/components/BarrelBreakdown.vue";
import { error } from "@/services/LoggerService";
import AdminBarrelHome from "@/components/AdminBarrelHome.vue";
import MangeUnpackedItems from "@/components/ManageUnpackedItems.vue";
import CollapsibleAdminOptions from "@/components/CollapsibleAdminOptions.vue";
import ScreenMixin from "@/mixins/ScreenMixin";
import ManageBarrelExpiration from "@/components/ManageBarrelExpiration.vue";
import ManagePromotionalCodes from "@/components/ManagePromotionalCodes.vue";
import ManageDeliveryCosts from "@/components/ManageDeliveryCost.vue";
import ManageCustomers from "@/components/ManageCustomers.vue";
import ManageNotificationEmails from "@/components/ManageNotificationEmails.vue";
import ManageWorkers from "@/components/ManageWorkers.vue";
import ManagePayments from "@/components/ManagePayments.vue";

export default mixins(ScreenMixin).extend({
  name: "Admin",
  components: {
    BarrelBreakdown,
    AddItem,
    AdminBarrelHome,
    ManageCategories,
    AddWorker,
    MangeUnpackedItems,
    CollapsibleAdminOptions,
    ManageBarrelExpiration,
    ManagePromotionalCodes,
    ManageDeliveryCosts,
    ManageCustomers,
    ManageNotificationEmails,
    ManageWorkers,
    ManagePayments
  },
  data() {
    return {
      barrels: [],
      selectedBarrel: "",
      item: {},
      activeComponent: {},
      addItem: AddItem,
      home: AdminBarrelHome,
      categories: ManageCategories,
      addWorker: AddWorker,
      unpacked: MangeUnpackedItems,
      barrelExpiration: ManageBarrelExpiration,
      promotionalCodes: ManagePromotionalCodes,
      deliveryCosts: ManageDeliveryCosts,
      customerTable: ManageCustomers,
      notificationEmails: ManageNotificationEmails,
      workersTable: ManageWorkers,
      managePayments: ManagePayments
    };
  },
  computed: {
    largeScreen(){
      return this.screenWidth >= 992;
    },
    adminOptions(){
      return [
        {label: 'Manage Barrels', view: this.home},
        {label: 'Manage Unpacked Items', view: this.unpacked},
        {label: 'Manage Categories', view: this.categories},
        {label: 'Manage Barrel Expiration', view: this.barrelExpiration},
        {label: 'Manage Promotional Codes', view: this.promotionalCodes},
        {label: 'Manage Delivery Costs', view: this.deliveryCosts},
        {label: 'Manage Customers', view: this.customerTable, hash: "#manageCustomer"},
        {label: 'Manage Notification Emails', view: this.notificationEmails, hash: "#manageNotificationEmails"},
        {label: 'Add Worker', view: this.addWorker},
        {label: 'Manage Workers', view: this.workersTable},
        {label: 'Manage Payments', view: this.managePayments}
      ]
    }
  },
  methods: {
    updateNotif(){
      this.$emit('updateNotification');
    },
    async setView(component) {
      try {
        this.activeComponent = component;
      } catch (e) {
        error(e);
      }
    },
    async view(option){
      this.setView(option.view);
    },
    handleHash(hash){
      try{
        if(!hash){
          this.setView(this.home);
          return;
        }
        const option = this.adminOptions.find(o => o.hash === hash);

        if(!option){
          this.setView(this.home);
          return;
        }

        this.view(option);
      }catch(e){
        error(e);
        this.setView(this.home);
      }
    }
  },
  async beforeMount() {
    this.handleHash(this.$route.hash);
  },
});
</script>

<style></style>
